import { useShowQuickTips } from "common/hooks";
import { ReadOnlyMode, WriteMode } from "components/AnalysisRenderMode";
import Alert from "components/Alert";

export default function Select(props) {
    const { id, name, value, label, placeholder, options, noLabel, required, dataWidth, disabled, autoFocus, onChange, meta, tip } = props;

    const hasError = meta && meta.touched && meta.error;

    const showQuickTips = useShowQuickTips();

    const selectedOption = options.find((option) => option.value === value);

    return (
        <div className={`Field${hasError ? " has-error" : ""}`} data-width={dataWidth}>
            <label className="Select Select--block" htmlFor={name}>
                {noLabel !== true && (
                    <label htmlFor={id || name} className="Field-label">
                        {label}
                        <WriteMode>
                            {required === true && <sup className="required">*</sup>}
                        </WriteMode>
                    </label>
                )}
                <WriteMode>
                    <select name={name} id={id || name} value={value || ""} onChange={onChange} disabled={disabled} autoFocus={autoFocus === true}>
                        {placeholder && (
                            <option value="" disabled={true}>
                                {placeholder}
                            </option>
                        )}
                        {options &&
                            options.map((option) => (
                                <option key={option.value} value={option.value}>
                                    {option.text}
                                </option>
                            ))}
                    </select>
                </WriteMode>
                <ReadOnlyMode>
                    <div className="u-mt-sm u-mb-sm">
                        <span>{selectedOption?.text || 'No option selected'}</span>
                    </div>
                </ReadOnlyMode>
            </label>
            {hasError && (
                <small id={`${id || name}-error`} className="Field-error">
                    {meta.error}
                </small>
            )}
            {showQuickTips && tip && <Alert type="help" text={tip} />}
        </div>
    );
};
